import React from "react";
import { assets } from "../../../assets/assets";
import PhoneFrameVideo from "../../../pages/Marketing/components/PhoneFrameVideo";
import { MARKETING_MEDIA } from "../../../config/marketing/media";

export default function AssistantMedia() {
    return (
        <div className="flex justify-center bg-bg-subtle p-6 rounded-tr-2xl">
            <PhoneFrameVideo
                videoSrc={MARKETING_MEDIA.doctorAIScreen.src}
                className="max-w-[260px]"
                poster={assets.doctor_portal_thumbnail}
            />
        </div>
    );
}
